module.exports = __webpack_public_path__ + "img/booking.764acc6f.png";